import { Component, Input, OnChanges, OnInit } from '@angular/core';
import {
  ControlContainer,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { distributionAssetsOptions } from '../../services/ref';

@Component({
    selector: 'distribution-assets',
    templateUrl: './distribution-assets.component.html',
    styleUrls: ['./distribution-assets.component.scss'],
    standalone: false
})
export class DistributionAssetsComponent implements OnInit, OnChanges {
  distributionAssetsForm: UntypedFormArray;

  options = distributionAssetsOptions;

  @Input() derrors: any = undefined;
  countries: any[];

  constructor(private controlContainer: ControlContainer) {}

  ngOnInit() {
    this.distributionAssetsForm = this.controlContainer
      .control as UntypedFormArray;
  }

  addFields() {
    this.distributionAssetsForm.push(
      new UntypedFormGroup({
        fundOrigin: new UntypedFormControl('LIQUIDITY', [Validators.required]),
        distribution: new UntypedFormControl(100, [Validators.required]),
      }),
    );

    this.distributionAssetsForm.markAsUntouched();
  }

  deleteFields(index) {
    this.distributionAssetsForm.removeAt(index);
  }

  ngOnChanges() {
    if (this.distributionAssetsForm)
      this.distributionAssetsForm.controls.forEach(control => {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      });
  }
}
